// extracted by mini-css-extract-plugin
export default {"footer":"ImageEditorSurveyFooter__footer--1pe2P","footer_button":"ImageEditorSurveyFooter__footer_button--RWgv8"};